module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_j_xanthic.9b1a13d4.png";